import { Box, Button, Typography } from '@mui/material'
import IntegrationCard from './IntegrationCard'
import styles from './integrationsModal.module.scss'

/**
 * `apps` is a bounded window, not the whole catalogue. Mounting all 1,070
 * toolkits — each an MUI Card with a Tooltip and a Button — froze the tab.
 */

/**
 * @param {{
 *   apps: object[],
 *   showPopularHeading?: boolean,
 *   emptyMessage?: string,
 *   onConnect?: (slug: string) => void,
 *   connectingSlug?: string | null,
 * }} props
 */
export default function IntegrationsGrid({
  apps,
  showPopularHeading = false,
  emptyMessage = 'No integrations match your filters.',
  onConnect = () => {},
  connectingSlug = null,
  hasMore = false,
  onShowMore = () => {},
}) {
  return (
    <Box className={styles.gridSection}>
      {showPopularHeading ? (
        <Typography component="h3" className={styles.gridSectionTitle}>
          Popular Integrations
        </Typography>
      ) : null}
      {apps.length === 0 ? (
        <Typography component="p" className={styles.gridEmpty}>
          {emptyMessage}
        </Typography>
      ) : (
        <Box className={styles.integrationsGrid} role="list">
          {apps.map((app) => (
            <Box key={app.slug} role="listitem" className={styles.gridCell}>
              <IntegrationCard
                app={app}
                onConnect={onConnect}
                isConnecting={connectingSlug === app.slug}
              />
            </Box>
          ))}
        </Box>
      )}
      {hasMore ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button size="small" variant="outlined" onClick={onShowMore}>
            Show more
          </Button>
        </Box>
      ) : null}
    </Box>
  )
}
